import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';

const SliderWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow-x: hidden;
  overflow-y: visible;
`;

const SliderList = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ItemSlide = styled.li`
  flex-shrink: 0;
  max-width: 327px;
  min-height: 153px;
`;

const CommentItem = styled.div`
  flex: 1;
  margin: 30px 6px 0px;
  padding: 24px;
  display: flex;
  min-height: 166px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  background: #f6f6f6;
`;

const StarsImg = styled.div`
  background-image: url('../assets/review-stars.png');
  width: 134px;
  height: 22px;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
`;

const Reviewer = styled.h3`
  text-align: left;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #7b7b7b;
`;

const Text = styled(Reviewer)`
  color: #5e5e5e;
`;

const ReviewSlider = ({ slideData }) => {
  const containerRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const handleTouchStart = (e) => {
    const startX = e.touches[0].clientX;
    let deltaX = 0;

    const handleTouchMove = (e) => {
      deltaX = e.touches[0].clientX - startX;
    };

    const handleTouchEnd = () => {
      if (deltaX !== 0) {
        const sensitivity = 50;
        if (deltaX > sensitivity) {
          handleSwipe('prev');
        } else if (deltaX < -sensitivity) {
          handleSwipe('next');
        }
      }

      deltaX = 0;
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };

    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);
  };

  const SlideItem = ({ id, reviewer, text }) => (
    <ItemSlide>
      <CommentItem key={id}>
        <StarsImg />
        <Reviewer>{reviewer}, 08/08/2023</Reviewer>
        <Text>{text}</Text>
      </CommentItem>
    </ItemSlide>
  );

  const slides = useMemo(() => {
    if (slideData.length > 1) {
      let items = slideData.map((data, index) => (
        <SlideItem key={index} reviewer={data.reviewer} text={data.text} />
      ));
      return [...items];
    }
  }, [slideData]);

  const handleSwipe = useCallback(
    (mode) => {
      containerRef.current.style.transitionDuration = '400ms';
      if (mode === 'prev') {
        if (current <= 1) {
          setTranslateX(0);
          setCurrent(0);
        } else {
          setTranslateX(327 * (current - 1));
          setCurrent((prev) => --prev);
        }
      } else if (mode === 'next') {
        if (current === slideData.length - 1) {
          setCurrent(slideData.length - 1);
        } else {
          setTranslateX(327 * (current + 1));
          setCurrent((prev) => ++prev);
        }
      }
    },
    [current, slideData]
  );

  useLayoutEffect(() => {
    setTranslateX(327 * current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const transitionEnd = () => {
      if (current <= 1) {
        containerRef.current.style.transitionDuration = '0ms';
        setTranslateX(327 * current);
      }
      if (current >= slideData.length) {
        containerRef.current.style.transitionDuration = '0ms';
        setTranslateX(327 * slideData.length);
      }
    };
    document.addEventListener('transitionend', transitionEnd);
    return () => {
      document.removeEventListener('transitionend', transitionEnd);
    };
  }, [current, slideData]);
  return (
    <>
      <SliderWrapper>
        <SliderList
          ref={containerRef}
          style={{
            transform: `translate3d(${-translateX}px, 0, 0)`,
          }}
          onTouchStart={handleTouchStart}
        >
          {slides}
        </SliderList>
      </SliderWrapper>
    </>
  );
};

export default ReviewSlider;
